export default __webpack_public_path__ + "static/media/Roobert-Medium.9c38b607.woff";